import React, { useState, useEffect, useRef } from 'react';
import { walletAmount, BbIcon, RobuxIcon, WalletValue, useAuth } from '../context/AuthContext';
import { motion, AnimatePresence } from 'framer-motion';
import { ShieldCheck, Dices, History, ArrowRightLeft, ChevronLeft, ChevronRight } from 'lucide-react';
import { toast } from 'sonner';
import { useChatLayout } from '../context/ChatLayoutContext';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';
const API = `${BACKEND_URL}/api`;

// ==========================================
// YENİ: K, M, B FORMATLAYICILARI (ÇİFT YÖNLÜ)
// ==========================================
const parseAmount = (valStr) => {
  if (!valStr) return 0;
  // ⚠️ BİNLİK AYIRICI TEMİZLENMELİ. formatAmount() büyük sayıları
  // toLocaleString ile üretiyor ("1,457,545"); parseFloat virgülde durup
  // 1 döndürüyordu. MAX butonuna basan kullanıcı 1 birim bahis oynuyordu.
  let str = valStr.toString().trim().toLowerCase().replace(/[,\s]/g, '');
  let multiplier = 1;
  if (str.endsWith('k')) { multiplier = 1000; str = str.slice(0, -1); }
  else if (str.endsWith('m')) { multiplier = 1000000; str = str.slice(0, -1); }
  else if (str.endsWith('b')) { multiplier = 1000000000; str = str.slice(0, -1); }
  
  const parsedValue = parseFloat(str);
  return isNaN(parsedValue) ? 0 : Math.floor(parsedValue * multiplier);
};

const formatAmount = (amount) => {
  if (amount === undefined || amount === null || amount === 0) return '';
  // Küsüratlı durumlarda gereksiz sıfırları temizlemek için parseFloat kullanıyoruz
  if (amount >= 1000000) return amount.toLocaleString();
  if (amount >= 1000) return parseFloat((amount / 1000).toFixed(2)) + 'K';
  return amount.toString();
};

export const Dice = () => {
  const { user, token, isAuthenticated, balance, fmtMoney, wallet, betToRaw, rawToBet, betLimits } = useAuth();
  const [betAmount, setBetAmount] = useState('');
  // 💬 Aç/kapa durumu paylaşımlı: sayfa değişse de korunur.
  const { chatOpen } = useChatLayout();
  
  // DICE OYUN STATELERİ
  const [target, setTarget] = useState(50.00); 
  const [condition, setCondition] = useState('over'); 
  const [isRolling, setIsRolling] = useState(false);
  const [lastRoll, setLastRoll] = useState(null); 
  const [history, setHistory] = useState([]);
  
  // SES EFEKTLERİ
  const tickSound = useRef(null);
  const winSound = useRef(null);
  const loseSound = useRef(null);
  
  const lastTickTime = useRef(0);
  const lastTickValue = useRef(50);

  useEffect(() => {
    if (typeof Audio !== "undefined") {
      tickSound.current = new Audio('/dice_tick.mp3'); 
      tickSound.current.preload = 'auto';

      winSound.current = new Audio('/towerWin.wav');
      winSound.current.preload = 'auto';

      loseSound.current = new Audio('/explosion.mp3');
      loseSound.current.preload = 'auto';
    }
  }, []);

  const playTickSound = () => {
      if (tickSound.current) {
          const soundClone = tickSound.current.cloneNode();
          soundClone.volume = 0.2;
          soundClone.play().catch(() => {});
      }
  };

  const getWinChance = (t, cond) => cond === 'over' ? 100 - t : t;
  const getMultiplier = (chance) => (95 / chance).toFixed(2);
  
  const winChance = getWinChance(target, condition);
  const multiplier = getMultiplier(winChance);

  const handleTargetChange = (val) => {
    let newTarget = parseFloat(val);
    if (isNaN(newTarget)) return;
    if (newTarget < 2.00) newTarget = 2.00;
    if (newTarget > 98.00) newTarget = 98.00;
    setTarget(parseFloat(newTarget.toFixed(2)));
  };

  const handleChanceChange = (val) => {
    let chance = parseFloat(val);
    if (isNaN(chance)) return;
    if (chance < 1.00) chance = 1.00;
    if (chance > 95.00) chance = 95.00;
    
    const newTarget = condition === 'over' ? 100 - chance : chance;
    setTarget(parseFloat(newTarget.toFixed(2)));
  };

  const handleMultiplierChange = (val) => {
    let mult = parseFloat(val);
    if (isNaN(mult)) return;
    if (mult < 1.01) mult = 1.01;
    if (mult > 95.00) mult = 95.00;
    
    let chance = 95 / mult;
    if (chance < 1.00) chance = 1.00;
    if (chance > 95.00) chance = 95.00;

    const newTarget = condition === 'over' ? 100 - chance : chance;
    setTarget(parseFloat(newTarget.toFixed(2)));
  };

  const toggleCondition = () => {
    setCondition(prev => prev === 'over' ? 'under' : 'over');
    setTarget(parseFloat((100 - target).toFixed(2))); 
  };

  const handleSliderChange = (e) => {
    const val = parseFloat(e.target.value);
    setTarget(val);

    const now = Date.now();
    if (Math.abs(val - lastTickValue.current) >= 1.0 || now - lastTickTime.current > 60) {
        playTickSound();
        lastTickValue.current = val;
        lastTickTime.current = now;
    }
  };

  // YENİ: K, M, B Destekli Hızlı Buton Fonksiyonları
  const handleBetChange = (val) => setBetAmount(val);
  const addBetAmount = (val) => {
    const current = parseAmount(betAmount);
    setBetAmount(String(current + val));
  };
  const multiplyBet = (mult) => {
    const current = parseAmount(betAmount);
    setBetAmount(String(Math.floor(current * mult)));
  };

  const rollDice = async () => {
    // 🎯 Kullanıcı AKTİF CÜZDANIN biriminde yazar (Robux → site birimi,
    // BB Coin → BB). betToRaw saklama birimine çevirir: BB'de ×1000.
    // Bu satır olmadan "10" yazan oyuncu 10 mili-BB (0,01 BB) oynardı.
    const amount = betToRaw(parseAmount(betAmount)); // YENİ: Sunucuya yollarken harfleri temiz tam sayıya çeviriyoruz
    
    if (!isAuthenticated) return toast.error("Please log in first!");
    // ⚠️ Limitler cüzdana göre; "1 – 100.000" SİTE birimidir ve
    // BB Coin bahislerini haksız yere reddederdi.
    if (!amount || amount < betLimits.min_bet || amount > betLimits.max_bet) {
      return toast.error(`Bet must be between ${walletAmount(betLimits.min_bet, wallet)} and ${walletAmount(betLimits.max_bet, wallet)}.`);
    }
    // 🍀 AKTİF CÜZDANIN bakiyesiyle karşılaştır (LC'de mili-LC).
    if (amount > balance) return toast.error("Insufficient balance!");

    setIsRolling(true);

    try {
      const response = await axios.post(`${API}/game/dice/roll`, {
        amount: amount,
        target: target,
        condition: condition
      }, { 
        headers: { Authorization: `Bearer ${token}` } 
      });
      
      const data = response.data;

      setLastRoll({
          result: data.result,
          win: data.win_amount > 0,
          seed: data.server_seed
      });

      setHistory(prev => [{ 
        id: Date.now(), 
        mult: data.win_amount > 0 ? data.multiplier : 0, 
        win: data.win_amount > 0 
      }, ...prev].slice(0, 10));

      if (data.win_amount > 0) {
          if (winSound.current) {
              const soundClone = winSound.current.cloneNode();
              soundClone.volume = 0.5;
              soundClone.play().catch(() => {});
          }
      } else {
          if (loseSound.current) {
              const soundClone = loseSound.current.cloneNode();
              soundClone.volume = 0.6;
              soundClone.play().catch(() => {});
          }
      }
      
    } catch (error) {
      if (error.response && error.response.status === 429) {
        toast.error("Too fast! Please slow down a bit. 🐢");
      } else {
        toast.error(error.response?.data?.detail || "An error occurred!");
      }
    } finally {
      setIsRolling(false);
    }
  };

  const getSliderTrackStyle = () => {
    const winColor = '#16A34A'; 
    const loseColor = '#f43f5e'; 
    
    if (condition === 'over') {
      return `linear-gradient(to right, ${loseColor} 0%, ${loseColor} ${target}%, ${winColor} ${target}%, ${winColor} 100%)`;
    } else {
      return `linear-gradient(to right, ${winColor} 0%, ${winColor} ${target}%, ${loseColor} ${target}%, ${loseColor} 100%)`;
    }
  };

  return (
    <div className="min-h-screen bg-[#0E0F11]" data-testid="dice-page">
      <div className="max-w-[1800px] mx-auto px-4 pt-24 pb-8">
        <div className={`flex flex-col lg:flex-row gap-6 transition-[padding] duration-300 ${chatOpen ? 'md:pl-[340px] lg:pl-[370px]' : ''}`}>
          
          {/* 💬 Sohbet App.js'te TEK kopya render ediliyor (ChatDock).
              Sayfa-içi kopya kaldırıldı: her gezinmede WebSocket kopup
              yeniden bağlanıyor ve 4 HTTP isteği tekrar atılıyordu. */}
          <main className="flex-1 flex flex-col lg:flex-row gap-6 min-w-0 lg:h-[calc(100vh-120px)]">
            
            {/* SOL SÜTUN: KONTROLLER */}
            <div className="w-full lg:w-80 flex-shrink-0 flex flex-col gap-4 h-full">
              <div className="bg-[#1A1D20] rounded-2xl border border-[#2A2D31] p-4 shadow-lg h-full flex flex-col">
                <div className="space-y-6 flex-1">
                  
                  {/* BAHİS GİRİŞİ VE BUTONLAR */}
                  <div>
                    <label className="text-xs text-zinc-400 font-bold mb-1.5 block uppercase tracking-wider">Bet Amount</label>
                    <div className="relative mb-3">
                      <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                        {/* Birim öneki AKTİF cüzdana göre; sabit "$" BB tarafında yanlıştı. */}
                        {wallet === 'lc' ? <BbIcon size={15} /> : <RobuxIcon size={15} />}
                      </div>
                      <input
                        type="text" // YENİ: Harf yazılabilmesi için type "number" yerine "text" oldu
                        value={betAmount}
                        onChange={(e) => handleBetChange(e.target.value)}
                        className="w-full bg-[#15171a] border border-[#2A2D31] rounded-xl py-3 pl-10 pr-4 text-white font-bold outline-none focus:border-[#B059E8] transition-colors uppercase"
                        placeholder="1"
                      />
                    </div>
                    <div className="grid grid-cols-4 gap-2">
                      <button onClick={() => addBetAmount(10)} className="py-2 text-xs font-bold text-zinc-300 bg-[#2A2D31]/50 hover:bg-[#33363b] rounded-lg transition-colors">+10</button>
                      <button onClick={() => multiplyBet(0.5)} className="py-2 text-xs font-bold text-zinc-300 bg-[#2A2D31]/50 hover:bg-[#33363b] rounded-lg transition-colors">1/2</button>
                      <button onClick={() => multiplyBet(2)} className="py-2 text-xs font-bold text-zinc-300 bg-[#2A2D31]/50 hover:bg-[#33363b] rounded-lg transition-colors">2x</button>
                      <button onClick={() => setBetAmount(String(rawToBet(balance || 0)))} className="py-2 text-xs font-bold text-[#c98bf0] bg-[#B059E8]/20 border border-[#B059E8]/30 hover:bg-[#B059E8]/40 rounded-lg transition-colors">MAX</button>
                    </div>
                  </div>

                  {/* PROFİT BİLGİSİ */}
                  <div className="bg-[#15171a] border border-[#2A2D31] rounded-xl p-4">
                     <span className="text-zinc-500 text-xs font-bold uppercase tracking-wider block mb-1">Profit on Win</span>
                     <span className="text-[#2ecf6e] mm-num font-bold text-xl">
                        {/* YENİ: Anlık kazanılacak parayı da K, M, B şeklinde süslüyoruz */}
                        <WalletValue amount={betAmount ? Math.floor(betToRaw(parseAmount(betAmount)) * multiplier) : 0} wallet={wallet} />
                     </span>
                  </div>

                </div>

                <div className="mt-auto pt-6">
                    <button 
                      onClick={rollDice}
                      disabled={isRolling || !betAmount}
                      className="w-full py-4 rounded-xl font-heading font-bold text-lg uppercase tracking-wider transition-all shadow-lg bg-gradient-to-r from-[#15913f] to-[#16A34A] hover:from-[#16A34A] hover:to-[#2ecf6e] text-white disabled:opacity-50 disabled:grayscale transform active:scale-95"
                    >
                      {isRolling ? 'ROLLING...' : 'ROLL DICE'}
                    </button>
                </div>
              </div>
            </div>

            {/* SAĞ SÜTUN: OYUN TAHTASI */}
            <div className="flex-1 flex flex-col items-center bg-[#1A1D20] rounded-2xl border border-[#2A2D31] shadow-2xl relative overflow-hidden h-full p-4 lg:p-8">
              
              <div className="absolute top-4 left-4 md:top-6 md:left-6 flex flex-col z-10">
                <div className="flex items-center gap-2 mb-2">
                    <Dices className="w-6 h-6 text-[#B059E8]" />
                    <span className="text-zinc-400 font-bold uppercase tracking-widest text-sm">Dice</span>
                </div>
              </div>

              {/* SAĞ ÜST GEÇMİŞ (HISTORY) SÜTUNU */}
              <div className="absolute top-4 right-4 md:top-6 md:right-6 flex flex-col items-center z-30 pointer-events-none">
                <span className="text-zinc-500 font-bold flex items-center gap-1 uppercase tracking-widest text-[9px] md:text-[10px] mb-2">
                  <History className="w-3 h-3" /> Recent
                </span>
                
                <div className="flex flex-col gap-1.5 overflow-hidden max-h-[250px] md:max-h-[300px] [mask-image:linear-gradient(to_bottom,white_70%,transparent_100%)] p-1">
                  <AnimatePresence>
                    {history.map((item) => (
                       <motion.div
                          layout 
                          key={item.id}
                          initial={{ opacity: 0, y: -20, scale: 0.8 }}
                          animate={{ opacity: 1, y: 0, scale: 1 }}
                          exit={{ opacity: 0, scale: 0.5, transition: { duration: 0.15 } }}
                          className={`w-12 h-8 rounded-md flex-shrink-0 flex items-center justify-center font-bold text-xs shadow-lg border-2 
                             ${item.win ? 'bg-[#16A34A]/20 text-[#2ecf6e] border-[#16A34A]/50' : 'bg-[#15171a] text-zinc-500 border-[#2A2D31]'}`}
                       >
                          {item.mult > 0 ? `${item.mult}x` : '0x'}
                       </motion.div>
                    ))}
                  </AnimatePresence>
                </div>
              </div>

              {/* ========================================== */}
              {/* DEV SLIDER ALANI */}
              {/* ========================================== */}
              <div className="flex-1 flex flex-col items-center justify-center w-full max-w-2xl mt-20 relative">
                 
                 {/* Custom Slider Track */}
                 <div className="relative w-full h-4 rounded-full shadow-inner mb-12 mt-10" style={{ background: getSliderTrackStyle() }}>
                    
                    {/* SONUÇ GÖSTERGESİ (YENİ VE KUSURSUZ) */}
                    <AnimatePresence>
                        {lastRoll && (
                            <motion.div
                                key={lastRoll.seed} 
                                initial={{ opacity: 0, y: -15, scale: 0.8 }}
                                animate={{ opacity: 1, y: 0, scale: 1 }}
                                exit={{ opacity: 0, scale: 0.8 }}
                                className="absolute bottom-full w-full left-0 z-30 pointer-events-none mb-3"
                            >
                                {/* Kutu (Taşmayı önlemek için clamp kullanır) */}
                                <div 
                                    className="absolute bottom-2 flex flex-col items-center"
                                    style={{ 
                                        left: `clamp(45px, ${lastRoll.result}%, calc(100% - 45px))`,
                                        transform: 'translateX(-50%)'
                                    }}
                                >
                                    <div className={`px-4 py-1.5 md:py-2 rounded-xl font-heading font-bold text-xl md:text-2xl shadow-xl border-2 whitespace-nowrap
                                        ${lastRoll.win ? 'bg-[#16A34A] text-white border-[#2ecf6e] shadow-[0_0_20px_rgba(22,163,74,0.5)]' : 'bg-rose-500 text-white border-rose-400 shadow-[0_0_20px_rgba(244,63,94,0.5)]'}
                                    `}>
                                        {lastRoll.result.toFixed(2)}
                                    </div>
                                </div>
                                {/* Küçük Ok (Asla kaymaz, tam sayının düştüğü % noktasını gösterir) */}
                                <div 
                                    className="absolute bottom-0"
                                    style={{ 
                                        left: `${lastRoll.result}%`,
                                        transform: 'translateX(-50%)'
                                    }}
                                >
                                    <div className={`w-0 h-0 border-l-[8px] border-r-[8px] border-t-[8px] border-l-transparent border-r-transparent mt-1
                                        ${lastRoll.win ? 'border-t-[#16A34A]' : 'border-t-rose-500'}
                                    `}></div>
                                </div>
                            </motion.div>
                        )}
                    </AnimatePresence>

                    {/* Görünmez HTML Range Input */}
                    <input
                       type="range"
                       min="2"
                       max="98"
                       step="0.01"
                       value={target}
                       onChange={handleSliderChange}
                       className="absolute inset-0 w-full h-full opacity-0 cursor-pointer z-20"
                    />

                    {/* Slider Kulbu (Thumb) */}
                    <div 
                       className="absolute top-1/2 -translate-y-1/2 w-8 h-10 bg-white rounded-lg shadow-[0_0_15px_rgba(255,255,255,0.5)] z-10 border-4 border-[#0E0F11] pointer-events-none flex items-center justify-center"
                       style={{ left: `${target}%`, transform: 'translate(-50%, -50%)' }}
                    >
                       <div className="w-1 h-4 bg-zinc-300 rounded-full"></div>
                    </div>

                    {/* Alttaki Sayılar */}
                    <div className="absolute top-8 left-0 w-full flex justify-between text-zinc-500 mm-num text-xs px-1 font-bold pointer-events-none">
                        <span>0</span>
                        <span>25</span>
                        <span>50</span>
                        <span>75</span>
                        <span>100</span>
                    </div>
                 </div>

                 {/* ========================================== */}
                 {/* MATEMATİK KUTULARI (Çarpan, Hedef, Şans) */}
                 {/* ========================================== */}
                 <div className="w-full bg-[#15171a] rounded-2xl border border-[#2A2D31] p-4 grid grid-cols-1 md:grid-cols-3 gap-4 shadow-inner mt-4">
                    
                    {/* ÇARPAN */}
                    <div className="bg-[#15171a] rounded-xl border border-[#2A2D31] p-2 flex flex-col items-center focus-within:border-[#B059E8] transition-colors">
                        <span className="text-[10px] text-zinc-500 uppercase tracking-widest font-bold mb-1">Multiplier</span>
                        <div className="flex items-center">
                            <input 
                                type="number" 
                                value={multiplier} 
                                onChange={(e) => handleMultiplierChange(e.target.value)}
                                className="bg-transparent text-white mm-num font-bold text-lg w-20 text-center outline-none"
                            />
                            <span className="text-zinc-600 font-bold ml-1">x</span>
                        </div>
                    </div>

                    {/* HEDEF VE YÖN (Roll Over / Under) */}
                    <div className="bg-[#15171a] rounded-xl border border-[#2A2D31] p-2 flex flex-col items-center focus-within:border-[#B059E8] transition-colors relative overflow-hidden group">
                        <span className="text-[10px] text-zinc-500 uppercase tracking-widest font-bold mb-1">
                            {condition === 'over' ? 'Roll Over' : 'Roll Under'}
                        </span>
                        <div className="flex items-center gap-2">
                            <input 
                                type="number" 
                                value={target.toFixed(2)} 
                                onChange={(e) => handleTargetChange(e.target.value)}
                                className="bg-transparent text-white mm-num font-bold text-lg w-20 text-center outline-none"
                            />
                        </div>
                        <button 
                            onClick={toggleCondition}
                            className="absolute right-0 top-0 bottom-0 w-12 bg-[#2A2D31]/50 hover:bg-[#B059E8]/20 text-zinc-400 hover:text-[#c98bf0] flex items-center justify-center transition-colors border-l border-[#2A2D31]"
                            title="Swap Over/Under"
                        >
                            <ArrowRightLeft className="w-4 h-4" />
                        </button>
                    </div>

                    {/* KAZANMA ŞANSI */}
                    <div className="bg-[#15171a] rounded-xl border border-[#2A2D31] p-2 flex flex-col items-center focus-within:border-[#B059E8] transition-colors">
                        <span className="text-[10px] text-zinc-500 uppercase tracking-widest font-bold mb-1">Win Chance</span>
                        <div className="flex items-center">
                            <input 
                                type="number" 
                                value={winChance.toFixed(2)} 
                                onChange={(e) => handleChanceChange(e.target.value)}
                                className="bg-transparent text-white mm-num font-bold text-lg w-20 text-center outline-none"
                            />
                            <span className="text-zinc-600 font-bold ml-1">%</span>
                        </div>
                    </div>

                 </div>
              </div>

              <div className="absolute bottom-4 left-4 right-4 flex flex-col md:flex-row items-center justify-between gap-2 text-[10px] md:text-xs text-zinc-500 mm-num pointer-events-none px-2 mt-10">
                <div className="flex items-center gap-1.5">
                  <ShieldCheck className="w-4 h-4 text-[#16A34A]" />
                  <span>Provably Fair</span>
                </div>
                {lastRoll?.seed && (
                  <div className="flex gap-4 w-full md:w-auto overflow-hidden opacity-70">
                      <span className="truncate text-[#16A34A]" title={lastRoll.seed}>
                        <span className="text-[#15913f]">Seed:</span> {lastRoll.seed.substring(0, 20)}...
                      </span>
                  </div>
                )}
              </div>

            </div>
          </main>
        </div>
      </div>
    </div>
  );
};